import Categorias from '../../../pages/Categorias'
import InfoRestaurante from '../../../pages/InfoRestaurante'
import Pedidos from '../../../pages/Pedidos'
import Perfil from '../../../pages/Perfil'
import Notificacao from '../../../pages/Notificacao'
import PerfilDados from '../../../pages/PerfilDados'
import PerfilEndereco from '../../../pages/PerfilEndereco'
import PerfilEsqueceuSenha from '../../../pages/PerfilEsqueceuSenha'
import MeusCartoes from '../../../pages/MeusCartoes'
import NoLocal from '../../../pages/NoLocal'
import Finalizar from "../../../pages/Finalizar";
import Pagamento from "../../../pages/Pagamento";
import Sacola from "../../../pages/Sacola";
import Promocoes from "../../../pages/Promocoes";
import Links from '../../../pages/Links'
import MeusPontos from '../../../pages/MeusPontos'
import MeusVouchers from '../../../pages/MeusVouchers'

export const lojaRoutes = [
  {
    path: '/categorias',
    name: 'Categorias',
    component: Categorias,
    meta: { page: 'Categorias', title: 'Cardápio' }
  },
  {
    path: '/info',
    name: 'InfoRestaurante',
    component: InfoRestaurante,
    meta: { page: 'InfoRestaurante', title: 'Empresa' }
  },
  {
    path: '/sacola',
    name: 'Sacola',
    component: Sacola,
    meta: { page: 'Sacola', title: 'Sacola' }
  },
  {
    path: '/promocoes',
    name: 'Promocoes',
    component: Promocoes,
    meta: { page: 'Promocoes', title: 'Promoções' }
  },
  {
    path: '/finalizar',
    name: 'Finalizar',
    component: Finalizar,
    meta: { page: 'Finalizar', title: 'Finalizar' }
  },
  {
    path: '/pagamento/:pedido',
    name: 'Pagamento',
    component: Pagamento,
    meta: { page: 'Pagamento', title: 'Pagamento' }
  },
  {
    path: '/pedidos',
    name: 'Pedidos',
    component: Pedidos,
    meta: { page: 'Pedidos', title: 'Meus Pedidos' }
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: Perfil,
    meta: { page: 'Perfil', title: 'Perfil' }
  },
  {
    path: '/notificacao',
    name: 'Notificacao',
    component: Notificacao,
    meta: { page: 'Notificacao', title: 'Notificações' }
  },
  {
    path: '/perfil/login',
    name: 'Login',
    component: PerfilDados,
    meta: { page: 'Login', title: 'Login' }
  },
  {
    path: '/perfil/cadastro',
    name: 'Cadastro',
    component: PerfilDados,
    meta: { page: 'Cadastro', title: 'Cadastro' }
  },
  {
    path: '/perfil/esqueci-senha',
    name: 'EsqueceuSenha',
    component: PerfilEsqueceuSenha,
    meta: { page: 'EsqueceuSenha', title: 'Esqueci a Senha' }
  },
  {
    path: '/perfil/enderecos',
    name: 'PerfilEndereco',
    component: PerfilEndereco,
    meta: { page: 'PerfilEndereco', title: 'Meus Endereços' }
  },
  {
    path: '/perfil/meus-dados',
    name: 'MeusDados',
    component: PerfilDados,
    meta: { page: 'MeusDados', title: 'Meus Dados' }
  },
  {
    path: '/perfil/telefone',
    name: 'Telefone',
    component: PerfilDados,
    meta: { page: 'Telefone', title: 'Meu Telefone' }
  },
  {
    path: '/perfil/meus-pontos',
    name: 'MeusPontos',
    component: MeusPontos,
    meta: { page: 'MeusPontos', title: 'Meus Pontos' }
  },
  {
    path: '/perfil/meus-vouchers',
    name: 'MeusVouchers',
    component: MeusVouchers,
    meta: { page: 'MeusVouchers', title: 'Meus Vouchers' }
  },
  {
    path: '/perfil/meus-cartoes',
    name: 'MeusCartoes',
    component: MeusCartoes,
    meta: { page: 'MeusCartoes', title: 'Meus Cartões' }
  },
  {
    path: '/home/nolocal',
    redirect: '/nolocal'
  },
  {
    path: '/nolocal',
    name: 'NoLocal',
    component: NoLocal,
    meta: { page: 'NoLocal', title: 'Pedido no Local' }
  },
  {
    path: '/fidelidade',
    name: 'Fidelidade',
    component: Promocoes,
    meta: { page: 'Fidelidade', title: 'Fidelidade' }
  },
  {
    path: '/links',
    name: 'Links',
    component: Links,
    meta: { page: 'Links', title: 'Links' }
  }
]
